// deps
import React, { memo } from "react";

// internal-deps
import { MROChildCart } from "@swiggy-private/cart-types";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

// helpers
import { getMROChildCartRestaurantImageId } from "@cart-ui/helpers/Mro";

interface RestaurantImageProps {
    cart: MROChildCart;
    height: string;
    width: string;
    alt?: string;
}

const RestaurantImage = ({ cart, height, width, alt }: RestaurantImageProps) => (
    <Image src={getCloudinaryUrl(getMROChildCartRestaurantImageId(cart))} height={height} width={width} alt={alt} />
);

export default memo(RestaurantImage);
